import Repository from './Repository';

const resource = '/store';

export default {
	store(store_id, payload) {
		return Repository.post(`${resource}/${store_id}/cashbox/flow`, payload);
	}
}